import { useConfig } from '@travelwin/core';
import { Helmet } from 'react-helmet-async';
import { helmetJsonLdProp } from 'react-schemaorg';
import { Thing, WithContext } from 'schema-dts';

import { isRemix } from '../../utils/ssrUtils';

interface Props {
  title: string;
  jsonLd?: WithContext<Thing>;
}

const HelmetWrapper = ({ title, jsonLd }: Props) => {
  const { BRAND_NAME } = useConfig();

  if (isRemix()) {
    // meta tags in Remix are defined using the meta export from route modules
    return null;
  }

  const structuredDataJsonLd = jsonLd ? [helmetJsonLdProp(jsonLd)] : undefined;

  return (
    <Helmet script={structuredDataJsonLd}>
      <title>{`${title} | ${BRAND_NAME}`}</title>
    </Helmet>
  );
};

export default HelmetWrapper;
